<p>{{ 'widget component!' | translate }}</p>